import React from 'react';
import type { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';

import { I18nProvider } from '@/i18n';
import { Tooltip } from '@/ui/Tooltip';

export type ProvidersProps = {
  children: React.ReactNode;
  queryClient: QueryClient;
};

export const Providers = ({ children, queryClient }: ProvidersProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <Tooltip.Provider delayDuration={300}>{children}</Tooltip.Provider>
      </I18nProvider>
    </QueryClientProvider>
  );
};
